"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toISOStringWithoutTimezone;
var _dateFns = require("date-fns");
function toISOStringWithoutTimezone(date) {
  if (typeof date === 'object' && date !== null) {
    return "".concat((0, _dateFns.format)(date, "yyyy-MM-dd'T'HH:mm:ss.SSS"), "Z");
  }
  return undefined;
}